/**
 * UniDecode解码
 */
/* eslint-disable */
const uniDecode = (a) => {
    if (!a) {
        return '';
    }
    a = a.replace(/\\/g, "%").replace("%u0025", "%25"), a = unescape(a.toString().replace(/%2B/g, "+"));
    var b = a.match(/(%u00([0-9A-F]{2}))/gi);
    if (b)
        for (var c = 0; c < b.length; c++) {
            var d = b[c].substring(1, 3),
                e = Number("0x" + d);
            e >= 128 && (a = a.replace(b[c], d))
        }
    return a = unescape(a.toString().replace(/%2B/g, "+")), a
}

/**
 * 转换参数
 * @param  {[type]} url [description]
 * @return {[type]}     [description]
 */
export const parseQueryString = (opts = {}) => {
    let url = opts && opts.url ? opts.url : window.location.href;

    //对url进行解码
    url = decodeURI(url);
    url = url.split('/#')[0]
    let reqParams = {};
    if (url.indexOf("?") > -1) {
        let str = url.split("?")[1], strs = str.split("&");
        strs.forEach(function (tempStr) {
            let tempArr = tempStr.split("=");
            if (tempArr[0]) {
                reqParams[tempArr[0]] = uniDecode(tempArr[1]);
            }
        });
    }
    return reqParams;
};
/**
 * 计算题目类型在数据库中存值所占大小
 * @param {*} types 问卷所有题目类型
 * @returns 
 */
export const counta = (types) => {
    let num = 0
    types.forEach(type => {
        switch (type) {
            // case 'checkbox':
            //     num += 600
            //     break
            case 'radio':
                num += 60
                break
            case 'matrix-rate':
                num += 50
                break
            // case 'textarea':
            //     num += 300
            //     break
        }
    })
    return num
}
/**
 * 持久化存储
 */
export const getStorage = (key) => {
    return JSON.parse(localStorage.getItem(key))
}
export const setStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value))
}
